import cloneDeep from 'lodash/cloneDeep'
import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'
import uploadFiles from '../../../utils/storage/uploadFiles'
import { GIFT_FUND_STORAGE_PATH } from './giftFundConstants'
import { stripLocalPhotoFields } from './mapGiftFundItem'

/**
 * Завантажує локальні фото в Storage і повертає масив метаданих для callable save.
 * Firestore оновлює лише callable (клієнтський write на giftFundItems заборонений).
 */
export const prepareGiftFundPhotosForSave = async (photos = [], docId) => {
  if (!docId) {
    throw new Error('prepareGiftFundPhotosForSave: потрібен docId')
  }

  const list = cloneDeep(Array.isArray(photos) ? photos : [])
  const photosToUpload = list.filter((photo) => photo?.needUpload && photo?.file)

  if (!isEmpty(photosToUpload)) {
    const uploadedPhotos = await uploadFiles({
      files: photosToUpload,
      storagePath: `${GIFT_FUND_STORAGE_PATH}/${docId}`,
    })

    uploadedPhotos.forEach((uploaded) => {
      const photo = find(list, ['fileName', uploaded.fileName])
      if (photo) {
        photo.publicUrl = uploaded.publicUrl
        photo.needUpload = false
        photo.storagePath = GIFT_FUND_STORAGE_PATH
      }
    })
  }

  return stripLocalPhotoFields(list)
}

export default prepareGiftFundPhotosForSave
